import React from "react";

function createMarkup(html) {
	return { __html: html };
}

const Player = ({ data }) => {
	return (
		<li>
			<div style={{ position: "relative" }}>
				<img className="image-shadow" src={data.img} alt={`${data.name}`} />
				<div className="player-flex-container">
					<div className="name-appearances">
						<span>{data.name}</span>
						<br />
						<span className="hometown">{data.locale}</span>

						<br />
						<span
							className="hometown"
							dangerouslySetInnerHTML={createMarkup(data.tt)}
						/>
					</div>
					<div className="right-flex-container">
						<div className={data.social.twitter ? "playerSocial" : "hidden"}>
							<a href={`https://twitter.com/${data.social.twitter}`}>
								<i className="fa fa-twitter-square fa-lg" />
							</a>
						</div>
						<div className={data.social.fb ? "playerSocial" : "hidden"}>
							<a href={`https://facebook.com/${data.social.fb}`}>
								<i className="fa fa-facebook-square fa-lg" />
							</a>
						</div>
						<div className={data.social.ig ? "playerSocial" : "hidden"}>
							<a href={`https://instagram.com/${data.social.ig}`}>
								<i className="fa fa-instagram fa-lg" />
							</a>
						</div>
						<div className={data.social.sc ? "playerSocial" : "hidden"}>
							<a href={`https://snapchat.com/${data.social.sc}`}>
								<i class="fa fa-snapchat-square fa-lg" />
							</a>
						</div>
					</div>
				</div>
				<div className="countryFlag">
					<img
						className="image-shadow"
						style={{ maxWidth: "100%", display: "block" }}
						src={`https://qnmcdn.qnm.workers.dev/tourneyweb.com/?path=%2Fassets%2Fflag-icons%2F${data.country}.png%3F607&ma=86400`}
						alt={`${data.country}`}
					/>
				</div>
				<div className="trophys-flex-container">
					<div className={data.other.major ? "majorChampion" : "hidden"}>
						<i className="fa fa-trophy" aria-hidden="true" />
					</div>
					<div className={data.other.vto ? "vtoChampion" : "hidden"}>
						<img
							src="https://vto.qnmcdn.com/assets/img/vto-champion-flag.png"
							alt="VTO Champion"
						/>
					</div>
				</div>
			</div>
		</li>
	);
};

export default Player;



// WEBPACK FOOTER //
// ./src/Player.js